import staticPosts, { BlogPost } from '../data/blogPosts';

export interface PaginatedResult {
  posts: BlogPost[];
  lastKey: string | null;
}

/**
 * Blog content is static for now (see frontend/src/data/blogPosts.ts).
 * The DynamoDB-backed blog API is being reworked on a separate branch —
 * this intentionally does not call it.
 */
export async function fetchPosts(category?: string): Promise<PaginatedResult> {
  const filtered = category && category !== 'All'
    ? staticPosts.filter((p) => p.category === category)
    : staticPosts;
  return { posts: filtered, lastKey: null };
}

export async function fetchPost(slugOrId: string | number): Promise<BlogPost | undefined> {
  const idNum = Number(slugOrId);
  const isNumeric = !isNaN(idNum);

  if (!isNumeric) {
    return staticPosts.find((p) => p.slug === slugOrId);
  }
  return staticPosts.find((p) => p.id === idNum);
}
